import classNames from "classnames";
import React from "react";
import { TooltipComponent } from "@fidget/common/components/tooltipComponent";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { UpgradeButton } from "@fidget/common/components/button/upgradeButton";
import styles from "./agentCallSection.css";

export interface Props {
  label: string;
  goToRoom?: () => any;
  close: () => void;
  callMaxDuration: number;
}

export const AgentLimitedCallEndedSection: React.SFC<Props> = ({
  label,
  goToRoom,
  close,
  callMaxDuration
}) => {
  return (
    <TooltipComponent
      positionPreset={"bottom"}
      text={intl.formatMessage("plan.upgrade.longerCalls", { minutes: callMaxDuration })}
    >
      <div className={classNames(styles["call-panel"], styles.orange)}>
        <div className={styles["call-info"]}>
          <div className={styles.caller}>
            <button className={styles.name} disabled={!goToRoom} onClick={goToRoom}>
              {label}
            </button>
          </div>
          <div className={styles.label}>
            {intl.formatMessage("plan.upgrade.calls.callEnded")}
            <span className={styles["call-timer"]}>{callMaxDuration}:00</span>
          </div>
        </div>
        <UpgradeButton text={intl.formatMessage("plan.upgrade.longerCalls.cta")} whiteStyle />
        <button className={styles["close-button"]} onClick={close}>
          <i className={"icon-close-cross"} />
        </button>
      </div>
    </TooltipComponent>
  );
};
